// src/app/core/state/menus/menus.reducer.ts

import { Action, createReducer, on } from '@ngrx/store';
import * as InsuredActions from './insured.actions';
import { initialState, InsuredState } from './insured.state';

const InsuredReducer = createReducer(
  initialState,
  on(
    InsuredActions.patchInsured,
    (state, action: ReturnType<typeof InsuredActions.patchInsured>) => ({
      ...state,
      insured: { ...state.insured!, ...action.payload }
    })
  ),
  on(InsuredActions.resetInsured, state => ({
    ...state,
    insured: initialState.insured
  })),
  on(
    InsuredActions.changeValidationStatus,
    (state, { isValid }: ReturnType<typeof InsuredActions.changeValidationStatus>) => ({
      ...state,
      isValid
    })
  ),
  on(InsuredActions.init, state => ({
    ...state,
    ...initialState
  })),
  on(InsuredActions.changeDurationWanted, (state, { duration }) => ({
    ...state,
    duration
  }))
);

export function reducer(state: InsuredState | undefined, action: Action) {
  return InsuredReducer(state, action);
}
